import React from 'react';
import './Footer.css';

const Footer = () => 
    <div className="footer text-center mt-5 p-3">Amanda Dovel</div>

export default Footer;